<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OffersList from "./offres";
import SuppliersApi from "@/services/suppliers-api";


/**
 * Projects-list component
 */
export default {
  page: {
    title: "Liste des Offres",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,  OffersList },
  data() {
    return {
      daterange: null,
      suppliersList:[],
      selected:null,
      selectedSupplier:null,
      before:null,
      after:null,
      start:null,
      end:null,
      isActiveOffer:true,

    };
  },

  mounted(){
    this.getSuppliers()
  },

  methods :{
    setOfferStatus(){
      this.isActiveOffer = !this.isActiveOffer
    },
    getSuppliers(){
      SuppliersApi.getAllSuppliers(false).then(
        response => {
          this.suppliersList=response;
        }
      )
    }

  },

  watch: {
        selected: function() {
            this.selectedSupplier = this.selected ? this.selected.id : null
        },
        end: function(){
          this.before = this.end? this.end : null
        },
        start: function(){
          this.after  = this.start? this.start : null
        }
    }
};
</script>
<template>
  <Layout>

    <div class="card border border-light mt-4 pt-4">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8 col-12">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Offres Provisoires & Groupées</h2>
          </div>
          <div class="col-md-4 col-12 text-right">
          <b-form-radio-group
            v-model="isActiveOffer"
            buttons
            :button-variant="isActiveOffer? 'outline-success' : 'outline-primary'"
            size="md"
            class="font-size-16  text-uppercase mt-md-0 mt-2"
            style="border-radius: 15px; min-width: 150px"
            @change="setOfferStatus"
          >
            <b-form-radio :value="true">
              <strong>Actives</strong>
            </b-form-radio>

            <b-form-radio :value="false">
              Anciennes
            </b-form-radio>
          </b-form-radio-group>

          </div>
        </div>

        <OffersList class="pt-4 mt-4" :selectedSupplier.sync=this.selectedSupplier :before.sync=this.before :after.sync=this.after :isActiveOffer="isActiveOffer" />

      </div>
    </div>

  </Layout>
</template>